// gkc_hash_code : 01E7J1BV41XHVJMHH8Y4PHXG7H
export const COMMON_ACTION = {
  SET_COLLAPSE_DATA: 'COMMON_ACTION/SET_COLLAPSE_DATA',
  SELECT_QUESTION: 'COMMON_ACTION/SELECT_QUESTION',
};
